import React, { useState } from 'react'
import { IPasswordConfirmProps } from '../../../types/interfaces/IPasswordConfirmProps'
import { PasswordInputContainer } from './style'
import { Input, Label, InputContainer } from '../input/style'
import { ShowPasswordButton } from '../show-password-button/style'
import { Error } from '../error/Error'
import { useSelector } from 'react-redux'
import { RootState, useAppSelector } from 'store/store'

export const PasswordConfirmInput: React.FC<IPasswordConfirmProps> = ({
  callback,
  hasError,
  labelText,
  errorText,
  password,
  className,
}) => {
  const [passwordType, setPasswordType] = useState<'password' | 'text'>(
    'password',
  )
  const { direction } = useSelector((state: RootState) => state.layout.language)
  const isLoading = useAppSelector((state) => state.layout.isLoading)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    const error = !(e.target.value === password)
    callback(e.target.value, error)
  }

  const togglePasswordType = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (passwordType === 'password') {
      setPasswordType('text')
      return
    }
    setPasswordType('password')
  }

  return (
    <InputContainer>
      <PasswordInputContainer
        className={`passwordConfirm ${className ?? ''} ${
          hasError ? 'error' : ''
        }`}
      >
        <Label htmlFor="passwordConfirm">
          {labelText || 'הקלידו שוב את הסיסמה שבחרתם'}
        </Label>
        <Input
          type={passwordType}
          name="passwordConfirm"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}
          disabled={isLoading}
        ></Input>
        <ShowPasswordButton
          direction={direction}
          onClick={togglePasswordType}
          type="button"
        >
          {passwordType === 'password' ? (
            <i className="password-eye"></i>
          ) : (
            <i className="password-eye-hide"></i>
          )}
        </ShowPasswordButton>
      </PasswordInputContainer>
      <Error hasError={hasError} errorText={errorText}></Error>
    </InputContainer>
  )
}
